import styled from "styled-components";

export const StyledSidebarSection = styled.div`
    display: flex;
    flex-flow: column;
    gap: ${(props) => props.theme.spacing[12]};
    min-width: 0;
    > * {
        max-width: 100%;
    }
`;
